.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
}

.body {
	font-size: 0.875rem;
	line-height: 1.5;
	color: var(--ink-muted);
	text-wrap: pretty;
}

.body p {
	margin: 0 0 var(--space-2) 0;
}

.body p:last-child {
	margin-bottom: 0;
}

.actions {
	display: flex;
	gap: var(--space-2);
	justify-content: flex-end;
}

.primary,
.secondary,
.destructive {
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-4);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.primary {
	background: var(--accent-sage);
	color: #fff;
	border: none;
}

.destructive {
	background: var(--accent-rose);
	color: #fff;
	border: none;
}

.secondary {
	background: none;
	color: var(--ink-muted);
	border: 1px solid var(--border);
}

.primary:disabled,
.secondary:disabled,
.destructive:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
